import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4db6a16f&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "../../less/activity.less?vue&type=style&index=0&id=4db6a16f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6a16f",
  null
  
)

export default component.exports